import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from "react-ga4";
import App from './App';
import 'Style/main.scss';

ReactGA.initialize('G-D44DS6XJJM');
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
